module.exports = __webpack_public_path__ + "resources/icon-sort.e173f990e800339a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-comment/img/icon-sort.png
// module id = 703
// module chunks = 0 1 2